import { Typography } from "@hellocarbo/lasagne";
import { TFunction } from "i18next";
import { Trans } from "react-i18next";

import { Percentiles, TCarbonUnit } from "@/types";

import { formatCarbon } from "./carbon";

export function getReductionMessage(
  t: TFunction,
  intensity: number,
  percentiles: Percentiles,
  unit: string
) {
  const { p20, p50 } = percentiles;

  if (intensity > p20) {
    const goal =
      intensity > p50
        ? { percentile: p50, top: "50" }
        : { percentile: p20, top: "20" };

    const { formattedCarbon } = formatCarbon(
      t,
      intensity - goal.percentile,
      TCarbonUnit.tCO2e,
      { shouldUnescape: true }
    );

    return (
      <Trans
        i18nKey="review:comparison.reductionMessage.reduceToReachTop"
        values={{
          value: formattedCarbon,
          top: goal.top,
          unit,
        }}
        shouldUnescape
        components={{
          bold: <Typography as="span" weight="bold" />,
        }}
      />
    );
  }

  return (
    <Trans
      i18nKey="review:comparison.reductionMessage.keepUpTheGoodWork"
      components={{
        bold: <Typography as="span" weight="bold" />,
      }}
    />
  );
}
